import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import api from '../../../services/api';

import { Container, Filter } from './styles';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import Loading from '../../../components/Loading';

export default class Events extends Component {
  state = {
    events: [],
    filterOption: 'active',
    loading: true,
    searchResults: [],
    searchInput: '',
  };

  filterOptions = [
    { value: 'active', text: 'Eventos ativos' },
    { value: 'finished', text: 'Eventos finalizados' },
    { value: 'pending_evaluation', text: 'Avaliação pendente' },
    { value: 'all', text: 'Todos os eventos' },
  ];

  componentDidMount() {
    this.loadEvents();
  }

  loadEvents = async () => {
    try {
      const { data } = await api.get('admin/events', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
        params: {
          approval_status: 'approved',
          results: 0,
        },
      });

      const formated = data.events.map(event => ({
        ...event,
        start_at: moment(event.start_at).format('DD/MM/YYYY'),
        end_at: moment(event.end_at).format('DD/MM/YYYY'),
        last_post_date: event.last_post_date
          ? moment(event.last_post_date).format('DD/MM/YYYY, HH:mm[h]')
          : null,
      }));

      this.setState({
        events: formated,
      });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({
        events: [],
      });
    }
  };

  handleSearch = (e) => {
    const { events } = this.state;
    this.setState({ searchInput: e.target.value }, () => {
      const { searchInput } = this.state;
      this.setState({
        searchResults: events.filter(event =>
          event.name.toLowerCase().includes(searchInput.toLowerCase())),
      });
    });
  };

  handleFilter = (e) => {
    this.setState({ filterOption: e.target.value });
  };

  render() {
    const {
      events, filterOption, loading, searchInput, searchResults,
    } = this.state;
    let filteredEvents = searchInput.length > 0 ? searchResults : events;
    if (filterOption !== 'all') {
      filteredEvents = filteredEvents.filter(event => event.status === filterOption);
    }
    return (
      <Container>
        {loading ? (
          <Loading />
        ) : (
          <div>
            <h1 className="page-title">Eventos aprovados {filteredEvents && ` (${filteredEvents.length})`}</h1>
            <div className="box">
              {this.state.events.length !== 0 && (
                <div className="box-header">
                  <Input
                    className="search-input"
                    name="searchInput"
                    onChange={this.handleSearch}
                    placeholder="Buscar evento"
                    value={searchInput}
                  />
                  <Filter>
                    <span>Filtrar por:</span>
                    <Select
                      value={filterOption}
                      options={this.filterOptions}
                      onChange={this.handleFilter}
                    />
                  </Filter>
                </div>
              )}
              {events.length !== 0 ? (
                <Fragment>
                  {filteredEvents.length > 0 ? (
                    <div className="cards-grid">
                      {filteredEvents.map(event => (
                        <div key={event.id} className="card card-small">
                          <Link
                            className="wrapper-link"
                            to={`/admin/dashboard/events/${event.id}`}
                          >
                            <div
                              className="card-image"
                              style={{
                                backgroundImage: `url(${event.cover})`,
                              }}
                            />
                            <div className="card-block">
                              <h4 className="card-title">{event.name}</h4>
                              <p className="card-text">
                                <strong>Início da divulgação: </strong>
                                <br />
                                {event.start_at}
                              </p>
                              <p className="card-text">
                                <strong>Fim da divulgação: </strong>
                                <br />
                                {event.end_at}
                              </p>
                              <p className="card-text">
                                {event.last_post_date ? (
                                  <Fragment>
                                    <strong>Última publicação: </strong>
                                    <br />
                                    {event.last_post_date}
                                  </Fragment>
                                ) : (
                                  <strong>Não possui publicações</strong>
                                )}
                              </p>
                              <p className="card-text">
                                <strong>Divulgadores ativos: </strong>
                                {event.active_promoters}
                              </p>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <h5 className="text-center">Nenhum evento encontrado.</h5>
                  )}
                </Fragment>
              ) : (
                <h5 className="text-center">Você ainda não criou nenhum evento.</h5>
              )}
            </div>
          </div>
        )}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/Events/index.js